'use strict';

const EVENT_GET_PAGE_INFO = 'iframeResizerGetPageInfo';
const addIframePageInfoListener = (handler) => {
    document.addEventListener(EVENT_GET_PAGE_INFO, handler);
};
const removeIframePageInfoListener = (handler) => {
    document.removeEventListener(EVENT_GET_PAGE_INFO, handler);
};

exports.EVENT_GET_PAGE_INFO = EVENT_GET_PAGE_INFO;
exports.addIframePageInfoListener = addIframePageInfoListener;
exports.removeIframePageInfoListener = removeIframePageInfoListener;
//# sourceMappingURL=IframePageInfoListener.js.map
